import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

interface HostsStructure {
    tennis: {
        confederations: string[];
        federations: string[];
    };
    pickleball: string[];
    golf: string[];
}

@Component({
    selector: 'app-host-selection-dialog',
    templateUrl: './host-selection-dialog.component.html',
    styleUrls: ['./host-selection-dialog.component.scss'],
})
export class HostSelectionDialogComponent implements OnInit {
    @Input() availableHosts: HostsStructure;
    @Input() currentHost: string = '';

    selectedHost: string = '';

    constructor(private dialogRef: NbDialogRef<HostSelectionDialogComponent>) {}

    ngOnInit() {
        this.selectedHost = this.currentHost;
    }

    selectHost(host: string) {
        this.selectedHost = host;
    }

    confirm() {
        this.dialogRef.close(this.selectedHost);
    }

    cancel() {
        this.dialogRef.close();
    }
}
